export const GatewayHome = () => {
    return (
        <>
            Gateway Home
        </>
    )
}